module.exports = __webpack_public_path__ + "img/zuijia_07.a6a4a349.png";